import { polyfill } from "es6-promise";
polyfill();

import Vue from "vue";
import Vuex from "vuex";

const state = {
  page_state: 0, //possible values: 0, 1, 2, 21 (21 is mobile)
  popup_state: "",
  popup_video_src: "",
  can_skip_videos: true,
  popup_img_src: "",
  unity_progress: 0,
  unity_info: "",
  form_status: 0,
  contact_form_status: 0,

  ambience_volume: 0.2,
  ambience_current_vol: 0,
  ambience_previous_vol: -1,
  voice_volume: 1,

  instructions_shown: false,

  sections: [
    {
      name: "Bleeding Disorders<br>Video",
      id: "1",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "video"
    },
    {
      name: "Back to<br>School",
      id: "2",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "pdf_list"
    },
    {
      name: "Zac &amp;<br>Factorman",
      id: "3",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "slideshow"
    },
    {
      name: "Factorman<br>Video",
      id: "4",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "video"
    },
    {
      name: "Kids Zone",
      id: "5",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "links_header"
    },
    {
      name: "Get Started<br>Today",
      id: "6",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "image"
    },
    {
      name: "Hemo<br>CareTeam",
      id: "7",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "pdf_slideshow"
    },
    {
      name: "Resource<br>Link",
      id: "8",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "external_link"
    },
    {
      name: "Hemo<br>101",
      id: "9",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "slideshow"
    },
    {
      name: "Specialty<br>Video",
      id: "10",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "video"
    },
    {
      name: "Literature<br>Info",
      id: "11",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "pdf_list"
    },

    {
      name: "Caricature Zone",
      id: "5_1",
      display_in_bar: false,
      display_in_footer: false,
      popup_type: "caricature_upload"
    },
    {
      name: "Game",
      id: "5_2",
      display_in_bar: false,
      display_in_footer: false,
      popup_type: "iframe"
    }
  ],

  sections_content: {
    event_info: {
      tag: "hfa"
    },
    "1": {
      type: "external_link",
      title: "https://www.cvs.com/content/health-hub",
      href: "https://www.cvs.com/content/health-hub",
      description: "Please click this link to view our Health Hub information"
    },
    "2": {
      type: "pdf_list",
      title: "Back to School",
      list: [
        {
          title: "Hemowise - Rule the School",
          filename: "2_Hemowise_Rule_the_School_English.pdf",
          thumb: "2_Hemowise_Rule_the_School_English.jpg"
        },
        {
          title: "Hemowise - Sports and Safety",
          filename: "3_Hemowise_Sports_and_Safety_English.pdf",
          thumb: "3_Hemowise_Sports_and_Safety_English.jpg"
        },
        {
          title: "School Preparedness Kit",
          filename: "1_School_Preparedness_Kit.pdf",
          thumb: "1_School_Preparedness_Kit.jpg"
        }
      ]
    },
    "3": {
      type: "slideshow",
      title: "Slideshow Popup",
      filename_prefix: "ZacBook_",
      count: 12,
      filetype: "jpg"
    },
    "5": {
      type: "links_header",
      title: "Kids Zone",
      top_list: [
        {
          title: "Caricature Zone",
          type: "popup",
          href: "5_1",
          thumb: "popup1.png"
        },
        {
          title: "Game",
          type: "popup",
          href: "5_2",
          thumb: "popup1.png"
        }
      ],
      list: [
        {
          title: "Holiday Art Contest",
          filename: "CVS Holiday Card.pdf",
          thumb: "CVS-Holiday-Card.jpg"
        },
        {
          title: "FactorMan Coloring Page",
          description:
            "Please submit your finished artwork to Lindsay.Nation@cvshealth.com by 8/29/2021 for a chance to be featured on this year’s Bleeding Disorders Holiday Card.",
          filename: "FactorMan Coloring Page.pdf",
          thumb: "FactorMan-Coloring-Page.jpg"
        },
        {
          title: "FactorMan Games",
          filename: "FactorMan Games.pdf",
          thumb: "FactorMan-Games.jpg"
        },
        {
          title: "FactorMan Bleeding Disorders Maze",
          filename: "FactorMan Bleeding Disorders Maze.pdf",
          thumb: "FactorMan-Bleeding-Disorders-Maze.jpg"
        },
        {
          title: "Hemophilia Bingo",
          filename: "Hemophilia Certificate Portrait Comic Bingo Final.pdf",
          thumb: "Hemophilia-Certificate-Portrait-Comic-Bingo-Final.jpg"
        },
        {
          title: "Hemophilia Word Search",
          filename: "Hemophilia Word Seach NHF Final  to Brand.pdf",
          thumb: "Hemophilia-Word-Seach-NHF-Final--to-Brand.jpg"
        }
      ]
    },
    "5_1": {
      type: "caricature_upload"
    },
    "5_2": {
      type: "iframe",
      src: "static/game/"
    },
    "6": {
      type: "image",
      title: "",
      filename: "6.jpg"
    },
    "7": {
      type: "pdf_slideshow",
      title: "Hemo CareTeam",
      list: [
        {
          title: "Hemo CareTeam Specialists Brochure",
          filename_prefix: "1_Hemo-CareTeam-Specialists-",
          thumb: "1_Hemo-CareTeam-Specialists-1.png",
          count: 2,
          slide_ratio: 1080 / 1152,
          filetype: "jpg"
        },
        {
          title: "Hemo Clinical Advisors Bio - Ann",
          filename_prefix: "2_Hemo-CareTeam-Specialists-",
          thumb: "2_Hemo-CareTeam-Specialists-1.png",
          count: 2,
          slide_ratio: 1080 / 697,
          filetype: "jpg"
        },
        {
          title: "Hemo Clinical Advisors Bio - Brenda",
          filename_prefix: "3_Hemo-CareTeam-Specialists-",
          thumb: "3_Hemo-CareTeam-Specialists-1.png",
          count: 2,
          slide_ratio: 1080 / 697,
          filetype: "jpg"
        },
        {
          title: "Hemo Clinical Advisors Bio - Juli",
          filename_prefix: "4_Hemo-CareTeam-Specialists-",
          thumb: "4_Hemo-CareTeam-Specialists-1.png",
          count: 2,
          slide_ratio: 1080 / 697,
          filetype: "jpg"
        },
        {
          title: "Hemo Clinical Advisors Bio - Melissa",
          filename_prefix: "5_Hemo-CareTeam-Specialists-",
          thumb: "5_Hemo-CareTeam-Specialists-1.png",
          count: 2,
          slide_ratio: 1080 / 697,
          filetype: "jpg"
        }
      ]
    },
    "8": {
      type: "external_link",
      title:
        "https://www.cvsspecialty.com/wps/portal/specialty/patients/go?to=education-center/hemophilia",
      href:
        "https://www.cvsspecialty.com/wps/portal/specialty/patients/go?to=education-center/hemophilia",
      description:
        "Please click this link to view our Hemophilia and<br>other Bleeding Disorders Education and Resources"
    },
    "9": {
      type: "slideshow",
      title: "Slideshow Popup",
      filename_prefix: "Hemo101Brochure_",
      count: 8,
      filetype: "jpg"
    },
    "10": {
      type: "external_link",
      title:
        "https://www.youtube.com/watch?v=xy_k3bQ5Dgo&list=PLLUzEQYSggzIJSXheNla3vmc3q0-dWvJl&index=2&t=0s",
      href:
        "https://www.youtube.com/watch?v=xy_k3bQ5Dgo&list=PLLUzEQYSggzIJSXheNla3vmc3q0-dWvJl&index=2&t=0s",
      description: "Please click this link to view our CVS Specialty Video"
    },

    "11": {
      type: "pdf_list",
      title: "Literature Info",
      list: [
        {
          title: "Hemophilia - Examining Your Child for Bleeds",
          filename: "01_Examining Your Child for Bleeds.pdf",
          thumb: "1.jpg"
        },
        {
          title: "Hemophilia and Bleeding Disorders - Online Resources",
          filename: "02_Hemo and Bleeding Disorders Online Resources (1).pdf",
          thumb: "2.jpg"
        },
        {
          title: "Hemowise - Be Ready for ER Visits",
          filename: "03_Hemowise Be Ready for ER Visits English.pdf",
          thumb: "3.jpg"
        },
        {
          title: "Hemowise - Bone Health",
          filename: "04_Hemowise Bone Health English.pdf",
          thumb: "4.jpg"
        },
        {
          title: "Hemowise - Comprehensive Care",
          filename: "05_Hemowise Comprehensive Care.pdf",
          thumb: "5.jpg"
        },
        {
          title: "Hemowise - Controlling Joint Bleed",
          filename: "06_Hemowise Controlling Joint Bleed.pdf",
          thumb: "6.jpg"
        },
        {
          title: "Hemowise - Dental Care",
          filename: "07_Hemowise Dental Care English.pdf",
          thumb: "7.jpg"
        },
        {
          title: "Hemowise - Desmospressin & Fluid",
          filename: "08_Hemowise Desmospressin & Fluid.pdf",
          thumb: "8.jpg"
        },
        {
          title: "Hemowise - Emergency Preparedness",
          filename: "09_Hemowise Emergency Preparedness English.pdf",
          thumb: "9.jpg"
        },
        {
          title: "Hemowise - Healthy Eating ",
          filename: "10_Hemowise Healthy Eating English.pdf",
          thumb: "10.jpg"
        },
        {
          title: "Hemowise - Know your NSAIDs & Aspirin Products",
          filename: "11_Hemowise Know your NSAIDs & Aspirin Products.pdf",
          thumb: "11.jpg"
        },
        {
          title: "Hemowise - Managing Head Injuries",
          filename: "12_Hemowise Managing Head Injuries.pdf",
          thumb: "12.jpg"
        },
        {
          title: "Hemowise - Overcoming Inhibitors",
          filename: "13_Hemowise Overcoming Inhibitors English.pdf",
          thumb: "13.jpg"
        },
        {
          title: "Hemowise - Preparing For Surgery",
          filename: "14_Hemowise Preparing For Surgery English.pdf",
          thumb: "14.jpg"
        },
        {
          title: "Hemowise - Proactive Joint Health",
          filename: "15_Hemowise Proactive Joint Health English.pdf",
          thumb: "15.jpg"
        },
        {
          title: "Hemowise - Prophylaxis",
          filename: "16_Hemowise Prophylaxis English.pdf",
          thumb: "16.jpg"
        },
        {
          title: "Hemowise - Travel Tips",
          filename: "17_Hemowise Travel Tips English.pdf",
          thumb: "17.jpg"
        },
        {
          title: "Hemowise - Understanding Ports",
          filename: "18_Hemowise Understanding Ports.pdf",
          thumb: "18.jpg"
        },
        {
          title: "Hemowise - Women's Joint Health",
          filename: "19_Hemowise Women's Joint Health English.pdf",
          thumb: "19.jpg"
        },
        {
          title: "Hemowise - Women's Transition to Menopause",
          filename: "20_Hemowise Women's Transition to Menopause English.pdf",
          thumb: "20.jpg"
        },
        {
          title: "Understanding Insurance",
          filename: "21_Hemo Understanding Insurance (1).pdf",
          thumb: "21.jpg"
        },
        {
          title: "5 Things to Know About Our Bleeding Disorder Care Program",
          filename: "22_75-52330A_BleedingDisorder-101_071720.pdf",
          thumb: "22.jpg"
        },
        {
          title: "Hemowise - Rule the School",
          filename: "Hemowise_Rule_the_School_English.pdf",
          thumb: "Hemowise_Rule_the_School_English.jpg"
        },
        {
          title: "Hemowise - Sports and Safety",
          filename: "Hemowise_Sports_and_Safety_English.pdf",
          thumb: "Hemowise_Sports_and_Safety_English.jpg"
        },
        {
          title: "Hemophilia CareTeam Specialists Brochure",
          filename: "Hemo CareTeam Specialists Brochure.pdf",
          thumb: "Hemo-CareTeam-Specialists_thumb.jpg"
        }
      ]
    }
  },

  footer_additional_links: [
    { title: "CVS Health", href: "https://www.cvshealth.com/" },
    {
      title: "CVS Specialty",
      href: "https://www.cvsspecialty.com/wps/portal/specialty"
    },
    { title: "Coram", href: "https://www.coramhc.com/" },
    { title: "Omnicare", href: "https://www.omnicare.com/" },
    { title: "CVS Health Jobs", href: "https://jobs.cvshealth.com/" }
  ],

  current_section: "",
  app_state: -1,
  initial_movement_mode: "AUTO",
  app_type: "desktop",

  booth_form: {
    name: "",
    last_name: "",
    email: ""
  },

  browser: null,
  browser_is_mobile: false,

  //general site options, be careful with this
  site_config: {
    use_intro_image: true,
    use_intro_video: true,
    use_footer_as_links: true,
    validate_form: true,
    fake_mobile: false
  }
};

const mutations = {
  SET_PAGE_STATE(state, val) {
    state.page_state = val;
  },
  SET_POPUP_STATE(state, val) {
    console.log("set_popup_state", val);
    state.popup_state = val;
  },
  SET_UNITY_PROGRESS(state, val) {
    state.unity_progress = val;
  },
  SET_UNITY_INFO(state, val) {
    state.unity_info = val;
  },
  SET_FORM_STATUS(state, val) {
    state.form_status = val;
  },
  SET_CONTACT_FORM_STATUS(state, val) {
    state.contact_form_status = val;
  },
  SET_VIDEO_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "video";
  },
  SET_IMAGE_POPUP(state, val) {
    state.popup_img_src = val;
    state.popup_state = "image";
  },
  SET_SLIDESHOW_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "slideshow";

    console.log(state);
  },
  SET_LINKS_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "links";
  },
  SET_CONTACT_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "form";
  },
  SET_ACTIVE_SECTION(state, val) {
    console.log("setting active section to ", val);
    state.current_section = val;
  },
  SET_APP_STATE(state, val) {
    state.app_state = val;
  },

  SET_SIMPLE_VAL(state, obj) {
    state[obj.name] = obj.val;
  },
  SAVE_BOOTH_FORM(state, obj) {
    state.booth_form = JSON.parse(JSON.stringify(obj));
    state.form_status = 1;
  },

  SAVE_INITIAL_MOVEMENT_FORM(state, app_mode) {
    state.initial_movement_mode = app_mode;
    console.log("initial app mode", state.initial_movement_mode);
  },

  SET_BROWSER_IDENTITY(state, browser) {
    state.browser = browser;
  }
};

const actions = {
  set_page_state({ commit }, val) {
    commit("SET_PAGE_STATE", val);
  },
  set_popup_state({ commit }, val) {
    commit("SET_POPUP_STATE", val);
  },
  set_video_popup({ commit }, val) {
    commit("SET_VIDEO_POPUP", val);
  },

  set_image_popup({ commit }, val) {
    commit("SET_IMAGE_POPUP", val);
  },
  set_slideshow_popup({ commit }, val) {
    commit("SET_SLIDESHOW_POPUP", val);
  },
  set_links_popup({ commit }, val) {
    commit("SET_LINKS_POPUP", val);
  },
  set_contact_popup({ commit }, val) {
    commit("SET_CONTACT_POPUP", val);
  },
  set_unity_progress({ commit }, val) {
    commit("SET_UNITY_PROGRESS", val);
  },
  set_unity_info({ commit }, val) {
    commit("SET_UNITY_INFO", val);
  },
  set_current_section({ commit }, val) {
    commit("SET_ACTIVE_SECTION", val);
  },
  set_app_state({ commit }, val) {
    commit("SET_APP_STATE", val);
  },
  set_simple_val({ commit }, obj) {
    commit("SET_SIMPLE_VAL", obj);
  },
  set_browser_identity({ commit }, obj) {
    commit("SET_BROWSER_IDENTITY", obj);
  },
  submit_form({ commit }, data) {
    if ("undefined" != typeof data.skip_form && data.skip_form == true) {
      commit("SAVE_INITIAL_MOVEMENT_FORM", data.app_mode);
      commit("SET_FORM_STATUS", 1);
      setTimeout(
        function () {
          commit("SET_FORM_STATUS", 2);
          commit("SET_PAGE_STATE", 2);
        }.bind(this),
        2000
      );
      return;
    }

    const axios = require("axios");

    commit("SET_FORM_STATUS", 1);
    if ("undefined" != typeof data.cancel_form) {
      //we shouldn't save the form data to be used later
    } else {
      commit("SAVE_BOOTH_FORM", data);
    }
    commit("SAVE_INITIAL_MOVEMENT_FORM", data.app_mode);
    let axiosConfig = {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Access-Control-Allow-Origin": "*"
    };

    axios({
      method: "post",
      url: "https://cvsspecialty.protoexpo.com/process_intro_form.php",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    })
      .then(function (response) {
        commit("SET_FORM_STATUS", 2);
        commit("SET_PAGE_STATE", 2);
      })
      .catch(function (error) {
        console.log(error);
        commit("SET_FORM_STATUS", 2);
        commit("SET_PAGE_STATE", 2);
      });
  },

  submit_photo_data({ commit }, data) {
    const axios = require("axios");
    const config = {
      headers: { "content-type": "multipart/form-data" }
    };
    console.log(data);
    return new Promise((resolve, reject) => {
      axios
        .post(
          "https://cvsspecialty.protoexpo.com/cms_admin/api/portrait/upload",
          //"http://100.50.20.65/test",
          data,
          config
        )
        .then((response) => {
          console.log(response.data);
          resolve();
        })
        .catch((error) => reject());
    });
  }

  /*submit_contact_form({ commit }, data) {
    const axios = require("axios");

    commit("SET_CONTACT_FORM_STATUS", 1);

    console.log(data);

    axios({
      method: "post",
      url: "https://cvsspecialty.protoexpo.com/process_intro_form.php",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    })
      .then(function (response) {
        commit("SET_CONTACT_FORM_STATUS", 2);
      })
      .catch(function (error) {
        console.log(error);
        commit("SET_CONTACT_FORM_STATUS", 3);
      });
  }*/
};

const getters = {
  appBarSections: (state) => {
    return state.sections.filter((section) => section.display_in_bar);
  },
  footerBarSections: (state) => {
    return state.sections.filter((section) => section.display_in_footer);
  },
  getSection: (state) => {
    return (section_id) => {
      let section = null;
      state.sections.forEach((item) => {
        if (item.id == section_id) {
          section = item;
        }
      });
      return section;
    };
  },
  sectionContent: (state) => {
    return (section_id) => {
      return state.sections_content[section_id];
    };
  },
  sectionCount: (state) => {
    return state.sections.length;
  },
  eventTag: (state) => {
    return state.sections_content.event_info.tag;
  }
};

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== "production"
});



// WEBPACK FOOTER //
// ./src/store/index.js